import { useQuery } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

// GET /admin/requests/:id/document-access-log — every proforma/payment-PDF
// open or download recorded for this request (security-hardening task, item
// 6). Rendered as a collapsible section on pages/ApprovalDetailPage.jsx —
// the closest thing this console has to a per-request "admin request
// detail" view today.
export function useDocumentAccessLog(requestId) {
  return useQuery({
    queryKey: ['admin', 'documentAccessLog', requestId],
    queryFn: () => apiClient.get(`/admin/requests/${requestId}/document-access-log`),
    select: (data) => data.entries,
    enabled: Boolean(requestId),
  });
}

export default useDocumentAccessLog;
